<template>
  <button type="button">Press Me</button>
</template>

<script>
export default {

}
</script>

<style>

</style>